import { useCallback } from 'react'
import ProcessEmissionsAssetEmissionCalculateButton from './ProcessEmissionsAssetEmissionCalculateButton'
import { TableCell, TableRow, TableRowHeader } from '@/common'
import { UnitLabel } from '@/shared/config/config'
import useI18n from '@/shared/hooks/useI18n'
import { EmissionTypeToReport } from './ProcessEmissionsSection'

export default function Co2ProcessEmissionTableRow({
  assetWithMetadata,
  setIsAddingEmission,
  isViewMode,
  removeEmissionRecord
}: {
  assetWithMetadata: EmissionTypeToReport
  removeEmissionRecord: (id: string) => void
  setIsAddingEmission: (
    emission: {
      productionRouteAssetId: number
      emissionType: string
      method: string
    } | null
  ) => void
  isViewMode: boolean
}) {
  const { t, numberFormatter2Decimals } = useI18n()
  const {
    emissionType,
    possibleMethods,
    productionRouteAsset: { id, assetDefinitionId, isCustom, customName, customId },
    emissionRecord
  } = assetWithMetadata

  const onCalculateClick = useCallback(
    (emissionType: string, method: string) => {
      setIsAddingEmission({
        productionRouteAssetId: id,
        emissionType: emissionType,
        method
      })
    },
    [id, setIsAddingEmission]
  )

  const onRemoveClick = useCallback(() => {
    removeEmissionRecord(emissionRecord?.id!)
  }, [emissionRecord?.id, removeEmissionRecord])

  const displayName = isCustom ? customName : t(`assets:${assetDefinitionId}`)
  const selectedCalculationMethod = emissionRecord?.method
  const hasSavedEmissionRecord = !!emissionRecord
  return (
    <tbody>
      <TableRow>
        <TableRowHeader className="text-left">{displayName}</TableRowHeader>
        <TableCell className="text-sm">{customId ?? '-'}</TableCell>
        <TableCell className="text-sm">
          {selectedCalculationMethod ? t(`calculationMethods.${selectedCalculationMethod}`) : '-'}
        </TableCell>
        <TableCell className="text-right">
          {emissionRecord?.emission
            ? `${numberFormatter2Decimals(emissionRecord?.emission)} ${UnitLabel.tCO2}`
            : '-'}
        </TableCell>
        <TableCell>
          {(emissionRecord ? [emissionRecord.method] : possibleMethods).map(method => (
            <ProcessEmissionsAssetEmissionCalculateButton
              key={method}
              emissionType={emissionType}
              onCalculateClick={onCalculateClick}
              isViewMode={isViewMode}
              method={method}
              hasEmissionRecord={hasSavedEmissionRecord}
              onRemove={onRemoveClick}
            />
          ))}
        </TableCell>
      </TableRow>
    </tbody>
  )
}
